import { useAssistantDock } from "./store";
import { useAssistantStatus } from "./hooks";

// Spec (dock flutuante) — estado de repouso do assistente: ícone Opus fixo no canto inferior direito.
// Aparece só quando habilitado e fechado; clique reabre o dock. O ✨ do Topbar + mod+j continuam.
// Fundo claro fixo (bg-white) p/ a marca (anel roxo + ponto laranja) ler em tema claro E escuro.
export function AssistantFab() {
  const enabled = useAssistantStatus().data?.enabled ?? false;
  const open = useAssistantDock((s) => s.open);
  const setOpen = useAssistantDock((s) => s.setOpen);
  if (!enabled || open) return null;
  return (
    <button
      type="button"
      aria-label="Abrir o assistente Opus"
      onClick={() => setOpen(true)}
      className="fixed bottom-4 right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full border border-border bg-white shadow-lg hover:shadow-xl motion-safe:transition-shadow"
    >
      <img src="/opus-mark.png" alt="" className="h-8 w-8" />
    </button>
  );
}
